import React, { useEffect } from "react";
import PrintInvoiceModal from "./Modal/PrintInvoiceModal";
import FileModal from "./Modal/FileModal";

import DatePicker from "./DatePicker";

import {
  deleteData,
  formatCurrency,
  getAlert,
  getData,
  getDataWithComp,
  parseCurrency,
} from "../../utils/SamuiUtils";
import { formatDate } from "../../utils/DateUtils";
import {
  uploadMultipleSlips,
  getMultipleSlips,
  deleteSingleSlip,
} from "../../utils/SamuiUtils";

const Breadcrumbs = ({
  page,
  isShowStatus,
  statusName,
  statusColour,
  otherStatusName,
  otherStatusColour,
  otherTypeName,
  otherTypeColour,
  docStatusForClosePK,
  items,
  docIsINV,
  onHandleClick,
  onHandlePayslip,
  onHandleCloseForWarehouse,
  onHandleCloseForAccount,
  onHandleInvoice1,
  onHandleInvoice2,
  onHandleInvoice3,
  urlImg,
  handleUploadSlip,
  base64Image,
  setBase64Image,
  handleUpdateSlip,
  docInvNo,
  isVatChecked,
  mode,
  openUploadAttach,
  setOpenUploadAttach,
  showViewAttachModal,
  setShowViewAttachModal,
  selectedFiles,
  selectedRecFiles,
  setSelectedFiles,
  handleRemoveImage,
  handleInputFileChange,
  handleBeforeUploadAttach,
}) => {
  const [showOptionInvModal, setShowOptionInvModal] = React.useState(false);
  const [showSlipModal, setShowSlipModal] = React.useState(false);

  // แสดงยอดเงินด้วย
  const [totalPrice, setTotalPrice] = React.useState(0);
  const [paymentHistory, setPaymentHistory] = React.useState([]);

  const [showChequeModal, setShowChequeModal] = React.useState(false);
  const [chequeNo, setChequeNo] = React.useState("");
  const [chequeName, setChequeName] = React.useState("");
  const [chequeBranch, setChequeBranch] = React.useState("");
  const [chequeDate, setChequeDate] = React.useState("");

  const [payDatetime, setPayDatetime] = React.useState("");

  const [masterBankDataList, setMasterBankDataList] = React.useState([]);
  const [bankDataList, setBankDataList] = React.useState([]);

  const [showConfirmRemoveModal, setShowConfirmRemoveModal] =
    React.useState(false);

  const [multipleSlipImages, setMultipleSlipImages] = React.useState([]);
  const [uploadedSlipFiles, setUploadedSlipFiles] = React.useState([]);
  const [selectedFileToDelete, setSelectedFileToDelete] = React.useState(null);
  const [showConfirmDeleteSingleFile, setShowConfirmDeleteSingleFile] =
    React.useState(false);

  useEffect(() => {
    const loadMasterData = async () => {
      const masterBankData = await getData(
        "Tb_Set_Bank_Master",
        "1 = 1 ORDER BY Bank_Master_Id ASC"
      );
      if (masterBankData && masterBankData.length > 0) {
        setMasterBankDataList(masterBankData);
      }
      const bankDataList = await getDataWithComp(
        "View_Set_Bank",
        "AND Bank_Status = 'Y' ORDER BY Bank_Id ASC"
      );
      if (bankDataList && bankDataList.length > 0) {
        setBankDataList(bankDataList);
      }

      setChequeBranch("ธนาคารกสิกรไทย");
    };
    loadMasterData();
  }, []);

  useEffect(() => {
    const getPayHistoryData = async () => {
      try {
        let response;

        // ตรวจสอบ pathname เพื่อเลือก API และเงื่อนไขที่ใช้
        if (window.location.pathname === "/billofsale") {
          response = await getDataWithComp(
            "API_0701_SO_H",
            `AND Doc_No = '${page}'`
          );
        } else if (window.location.pathname === "/bill") {
          response = await getDataWithComp(
            "API_1301_BL_H",
            `AND Doc_No = '${page}'`
          );
        } else if (window.location.pathname === "/payment-voucher") {
          response = await getDataWithComp(
            "API_0401_PAY_H",
            `AND Pay_No = '${page}'`
          );
        }

        if (response && response.length > 0) {
          // ตั้งค่ารวมยอดชำระ
          if (window.location.pathname === "/payment-voucher") {
            setTotalPrice(response[0].Total_Pay_Per);
          } else {
            setTotalPrice(response[0].Pay_Total);
          }

          // ดึงประวัติการชำระเงิน
          const paymentHistoryResponse = await getData(
            "Pay_History",
            `
            DocCode_Id = ${window.location.pathname === "/billofsale"
              ? 7
              : window.location.pathname === "/bill"
                ? 14
                : 4
            } 
            AND Doc_Id = ${window.location.pathname === "/billofsale"
              ? response[0].Doc_ID
              : window.location.pathname === "/bill"
                ? response[0].Doc_Id
                : response[0].Pay_Id
            }
          `
          );

          if (paymentHistoryResponse && paymentHistoryResponse.length > 0) {
            setPaymentHistory(paymentHistoryResponse);

            for (const payment of paymentHistoryResponse) {
              if (payment.Pay_Type === 3) {
                setChequeNo(payment.Pay_Cheque_No);
                setChequeName(payment.Pay_Cheque_Name);
                setChequeBranch(payment.Pay_Cheque_Branch);
                setChequeDate(formatDate(payment.Pay_Cheque_date, false));
              }

              setPayDatetime(formatDate(payment.Pay_Datetime, false));
            }
          }
        }
      } catch (error) {
        getAlert("FAILED", "พบข้อผิดพลาด ในการดึงข้อมูลใบขาย");
      }
    };

    if (
      window.location.pathname === "/billofsale" ||
      window.location.pathname === "/bill" ||
      window.location.pathname === "/payment-voucher"
    ) {
      getPayHistoryData();
    }
  }, [otherTypeName]);

  useEffect(() => {
    const fetchUploadedFiles = async () => {
      if (
        (window.location.pathname === "/bill" ||
          window.location.pathname === "/billofsale") &&
        paymentHistory.length > 0
      ) {
        try {
          const docId =
            window.location.pathname === "/billofsale"
              ? paymentHistory[0].Doc_Id
              : paymentHistory[0].Doc_Id;
          const docCodeId = window.location.pathname === "/billofsale" ? 7 : 14;

          if (docId) {
            const files = await getMultipleSlips(docId, docCodeId);
            setUploadedSlipFiles(files);
          }
        } catch (error) {
          console.error("Error fetching uploaded files:", error);
        }
      }
    };

    fetchUploadedFiles();
  }, [paymentHistory, showSlipModal]);
  const handleDeleteSingleFile = (file) => {
    setSelectedFileToDelete(file);
    setShowConfirmDeleteSingleFile(true);
  };

  const isHiddenPath = () => {
    const hiddenPaths = [
      "/initialdata",
      "/creditor",
      "/debtor",
      "/employee",
      "/tbsetitem",
      "/APtype",
      "/ARtype",
      "/company",
      "/dept",
      "/position",
      "/car",
      "/transType",
      "/docType",
      "/brand",
    ];
    return hiddenPaths.includes(window.location.pathname);
  };

  const handleConfirmDelete = async () => {
    try {
      setShowConfirmRemoveModal(false);

      if (
        window.location.pathname === "/billofsale" ||
        window.location.pathname === "/bill"
      ) {
        await deleteData("Upload_File_List", `WHERE File_Url = '${urlImg}'`);

        getAlert("OK", "ลบรูปภาพสลิปชําระเงินสําเร็จ");

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        getAlert(
          "FAILED",
          "ไม่สามารถรูปภาพสลิปชําระเงินได้ กรุณาติดต่อผู้ดูแลระบบ"
        );
      }
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบไฟล์ได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleMultipleSlipUpload = (event) => {
    const files = Array.from(event.target.files);

    // จำกัดไม่เกิน 3 ไฟล์
    if (files.length > 100) {
      getAlert("FAILED", "สามารถอัพโหลดได้ไม่เกิน 100 ไฟล์");
      return;
    }

    // ตรวจสอบว่าไฟล์ที่มีอยู่ + ไฟล์ใหม่ไม่เกิน 3 ไฟล์
    if (multipleSlipImages.length + files.length > 100) {
      getAlert(
        "FAILED",
        `สามารถอัพโหลดได้ไม่เกิน 100 ไฟล์ (ปัจจุบันมี ${multipleSlipImages.length} ไฟล์)`
      );
      return;
    }

    const newImages = [];
    let processedFiles = 0;

    files.forEach((file, index) => {
      if (
        file &&
        (file.type.startsWith("image/") || file.type === "application/pdf")
      ) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const base64 = e.target.result;
          newImages.push({
            id: Date.now() + index,
            base64: base64,
            name: file.name,
            type: file.type,
          });

          processedFiles++;

          // เมื่ออ่านไฟล์ครบแล้ว
          if (processedFiles === files.length) {
            setMultipleSlipImages((prev) => [...prev, ...newImages]);
          }
        };

        reader.onerror = () => {
          getAlert("FAILED", `ไม่สามารถอ่านไฟล์ ${file.name} ได้`);
        };

        reader.readAsDataURL(file);
      } else {
        getAlert("FAILED", `ไฟล์ ${file.name} ไม่ใช่รูปภาพที่รองรับ`);
      }
    });
  };

  const handleRemoveSlipImage = (imageId) => {
    setMultipleSlipImages((prev) => prev.filter((img) => img.id !== imageId));
  };

  const handleUploadMultipleSlips = async () => {
    if (multipleSlipImages.length === 0) {
      getAlert("FAILED", "กรุณาเลือกไฟล์สลิปอย่างน้อย 1 ไฟล์");
      return;
    }

    try {
      const slipFiles = multipleSlipImages.map((img) => img.base64);
      let docId = paymentHistory?.[0]?.Doc_Id;
      const docCodeId = window.location.pathname === "/billofsale" ? 7 : 14;

      if (!docId) {
        try {
          let resp;
          if (window.location.pathname === "/billofsale") {
            resp = await getDataWithComp("API_0701_SO_H", `AND Doc_No = '${page}'`);
            docId = resp?.[0]?.Doc_ID || resp?.[0]?.Doc_Id;
          } else if (window.location.pathname === "/bill") {
            resp = await getDataWithComp("API_1301_BL_H", `AND Doc_No = '${page}'`);
            docId = resp?.[0]?.Doc_Id;
          }
        } catch (e) {
          console.error("Fallback fetch Doc_Id failed:", e);
        }
      }

      if (!docId) {
        getAlert("FAILED", "ไม่พบข้อมูลเอกสาร");
        return;
      }

      const response = await uploadMultipleSlips(slipFiles, docId, docCodeId);

      if (response && response.status === "OK") {
        getAlert("OK", `อัพโหลดสลิปสำเร็จ ${response.total_uploaded} ไฟล์`);
        setMultipleSlipImages([]);

        // รีเฟรชไฟล์ที่อัพโหลดแล้ว
        const updatedFiles = await getMultipleSlips(docId, docCodeId);
        setUploadedSlipFiles(updatedFiles);
      } else {
        const msg = response?.message || response?.error || "อัพโหลดสลิปไม่สำเร็จ";
        getAlert("FAILED", msg);
        console.error("response:", response);
      }
    } catch (error) {
      console.error("Error uploading slips:", error);
      const serverMsg = error.response?.data?.message || error.message || "เกิดข้อผิดพลาดในการอัพโหลดสลิป";
      getAlert("FAILED", serverMsg);
    }
  };

  const confirmDeleteSingleFile = async () => {
    if (!selectedFileToDelete) return;

    try {
      await deleteSingleSlip(selectedFileToDelete.id);

      // อัพเดต state
      setUploadedSlipFiles((prev) =>
        prev.filter((file) => file.id !== selectedFileToDelete.id)
      );

      getAlert("OK", "ลบไฟล์สำเร็จ");
      setShowConfirmDeleteSingleFile(false);
      setSelectedFileToDelete(null);
    } catch (error) {
      console.error("Error deleting file:", error);
      getAlert("FAILED", "ไม่สามารถลบไฟล์ได้");
    }
  };

  return (
    <>
      <div
        className="page-header"
        style={{
          position: "fixed", // เปลี่ยนจาก relative เป็น fixed
          top: "0",
          left: "0",
          width: "100vw", // ขยายความกว้างให้เต็มหน้าจอ
          backgroundColor: "#f8f9fa",
          zIndex: "1000",
          padding: "15px 0",
          paddingLeft: "11%",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h1
          className="fw-bold"
          style={{ color: "#2A2F5B", paddingLeft: "1rem" }}
        >
          {page}
        </h1>
        <ul className="breadcrumbs">
          <li className="nav-home">
            <a href="/">
              <i className="icon-home fw-bold" style={{ color: "#EF6C00" }}></i>
            </a>
          </li>
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <li className="separator fw-bold" style={{ color: "#EF6C00" }}>
                <i className="icon-arrow-right fw-bold"></i>
              </li>
              <li className="nav-item">
                <a
                  className="fw-bold"
                  style={item.style || { color: "#EF6C00" }}
                  href={item.url}
                >
                  {item.name}
                </a>
              </li>
            </React.Fragment>
          ))}
        </ul>
        {isShowStatus && (
          <div style={{ display: "flex", marginLeft: "10px" }}>
            <div
              className="page-header col-12"
              style={{ marginBottom: "-1px" }}
            >
              <button
                className="btn btn-md w-100"
                style={{
                  backgroundColor: statusColour,
                  fontSize: "16px",
                  color: "white",
                  pointerEvents: "none",
                  userSelect: "none",
                }}
              >
                {statusName}
              </button>
            </div>
          </div>
        )}
        {/* ใช้สำหรับใบรับสินค้า แสดงสถานะจ่าย && แสดงสถานะการจัดส่งของ Picking List */}
        {otherStatusName && otherStatusColour && (
          <div style={{ display: "flex", marginLeft: "10px" }}>
            <div
              className="page-header col-12"
              style={{ marginBottom: "-1px" }}
            >
              <button
                className="btn btn-md w-100"
                style={{
                  backgroundColor: otherStatusColour,
                  fontSize: "16px",
                  color: "white",
                  pointerEvents: "none",
                  userSelect: "none",
                }}
              >
                {otherStatusName}
              </button>
            </div>
          </div>
        )}
        {/* ใช้สำหรับใบขาย แสดงสถานะประเภทจ่าย */}
        {otherTypeName === "จ่ายหลายช่องทาง" ? (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              marginLeft: "10px",
            }}
          >
            {paymentHistory.map((pay, index) => (
              <button
                key={index}
                className="btn btn-md"
                style={{
                  backgroundColor:
                    Number(pay.Pay_Type) === 1
                      ? "green"
                      : Number(pay.Pay_Type) === 2
                        ? "blue"
                        : Number(pay.Pay_Type) === 3
                          ? "purple"
                          : Number(pay.Pay_Type) === 4 || Number(pay.Pay_Type) === 7 || Number(pay.Pay_Type) === 8
                            ? "orange"
                            : "gray",
                  fontSize: "16px",
                  color: "white",
                  userSelect: "none",
                }}
                onClick={() => {
                  if (pay.Pay_Type === 2) {
                    setShowSlipModal(true);
                  }
                  if (pay.Pay_Type === 3) {
                    setShowChequeModal(true);
                  }
                }}
              >
                {Number(pay.Pay_Type) === 1
                  ? "เงินสด"
                  : Number(pay.Pay_Type) === 2
                    ? "เงินโอน"
                    : Number(pay.Pay_Type) === 3
                      ? "เช็ค"
                      : Number(pay.Pay_Type) === 4 || Number(pay.Pay_Type) === 7
                        ? "ค่าธรรมเนียม"
                        : Number(pay.Pay_Type) === 8
                          ? (pay.Pay_Remark || "อื่นๆ")
                          : "ไม่ทราบ"} {" "}
                ({formatCurrency(pay.Pay_Amount)} ฿)
              </button>
            ))}
          </div>
        ) : (
          otherTypeName &&
          otherTypeColour && (
            <div style={{ display: "flex", marginLeft: "10px" }}>
              <div
                className="page-header col-12"
                style={{ marginBottom: "-1px" }}
              >
                <button
                  className="btn btn-md w-100"
                  style={{
                    backgroundColor: otherTypeColour,
                    fontSize: "16px",
                    color: "white",
                    userSelect: "none",
                  }}
                  onClick={() => {
                    if (otherTypeName === "เงินโอน") {
                      setShowSlipModal(true);
                    }
                    if (otherTypeName === "เช็ค") {
                      setShowChequeModal(true);
                    }
                  }}
                >
                  {otherTypeName}{" "}
                  {totalPrice > 0 ? `(${formatCurrency(totalPrice)} ฿)` : null}{" "}
                  {otherTypeName === "เงินโอน" ? (
                    <i
                      className="fas fa-search-plus"
                      aria-hidden="true"
                      style={{ fontSize: "16px", color: "white" }}
                    ></i>
                  ) : null}
                </button>
              </div>
            </div>
          )
        )}
        <div style={{ marginRight: "30px" }} />
        <div
          className="d-flex align-items-center gap-2 flex-wrap"
          style={{ marginLeft: "auto", marginRight: "10px" }}
        >
          {/* ใช้สำหรับปิดงาน Vansale คืนสต็อกคลัง */}
          {window.location.pathname === "/picking-list" &&
            docStatusForClosePK === 2 && (
              // || docStatusForClosePK === 3 || docStatusForClosePK === 5
              <div style={{ marginRight: "10px" }}>
                <button
                  onClick={() => onHandleCloseForWarehouse()}
                  className="btn btn-lg"
                  style={{
                    backgroundColor:
                      docStatusForClosePK === 2 ? "red" : "#1572e8",
                    fontSize: "16px",
                    color: "white",
                  }}
                >
                  {docStatusForClosePK === 2
                    ? "ปิดงานคืนสต็อกคลัง"
                    : "ตรวจสอบคืนสต็อกคลัง"}
                </button>
              </div>
            )}
          {/* ใช้สำหรับปิดงาน Vansale บัญชี */}
          {window.location.pathname === "/picking-list" &&
            //docStatusForClosePK === 2 ||
            (docStatusForClosePK === 3 || docStatusForClosePK === 5) && (
              <div style={{ marginRight: "10px" }}>
                <button
                  onClick={() => onHandleCloseForAccount()}
                  className="btn btn-lg"
                  style={{
                    backgroundColor:
                      docStatusForClosePK === 3 ? "red" : "#1572e8",
                    fontSize: "16px",
                    color: "white",
                  }}
                >
                  {docStatusForClosePK === 3
                    ? "ปิดงานเงินบัญชี"
                    : "ตรวจสอบเงินบัญชี"}
                </button>
              </div>
            )}
          {/* ใช้สำหรับพิมพ์ รายงานขาย Vansale */}
          {window.location.pathname === "/picking-list" &&
            localStorage.getItem("company") === "2" &&
            docStatusForClosePK === 5 && (
              <div style={{ marginRight: "10px" }}>
                <button
                  onClick={() => onHandleInvoice1()}
                  className="btn btn-lg"
                  style={{
                    backgroundColor: "purple",
                    fontSize: "16px",
                    color: "white",
                  }}
                >
                  พิมพ์รายงานขาย Vansale
                </button>
              </div>
            )}
          {/* เอกสารแนบ */}

          {(((window.location.pathname === "/purchase-request" ||
            window.location.pathname === "/product-receipt" ||
            window.location.pathname === "/payment-voucher" ||
            window.location.pathname === "/icebox") && // เพิ่มบรรทัดนี้
            (mode === "I" || mode === "U")) ||
            (
              window.location.pathname === "/quotation" &&
              (mode === "I" || mode === "U")
            )) && ( // เช็คว่ามี status แสดงว่าเป็นหน้า view detail
              <>
                <button
                  hidden={isHiddenPath()}
                  onClick={() => setShowViewAttachModal(true)}
                  className="btn d-flex align-items-center justify-content-center position-relative"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    fontSize: "16px",
                    color: "white",
                    fontWeight: "bold",
                    padding: 0,
                    backgroundColor: "purple",
                  }}
                >
                  <i className="fa fa-paperclip"></i>
                  {(selectedFiles?.length > 0 ||
                    selectedRecFiles?.length > 0) && (
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {parseCurrency(selectedFiles?.length || 0) +
                          parseCurrency(selectedRecFiles?.length || 0)}
                      </span>
                    )}
                </button>
                {showViewAttachModal && (
                  <FileModal
                    mode={mode}
                    openUploadAttach={openUploadAttach}
                    setOpenUploadAttach={setOpenUploadAttach}
                    showViewAttachModal={showViewAttachModal}
                    setShowViewAttachModal={setShowViewAttachModal}
                    selectedFiles={selectedFiles}
                    selectedRecFiles={selectedRecFiles}
                    setSelectedFiles={setSelectedFiles}
                    handleRemoveImage={handleRemoveImage}
                    handleInputFileChange={handleInputFileChange}
                    handleBeforeUploadAttach={handleBeforeUploadAttach}
                  />
                )}
              </>
            )}
          {/* รายงาน */}
          {isShowStatus ? (
            <>
              {((docIsINV === "Y" &&
                window.location.pathname === "/billofsale" &&
                localStorage.getItem("company") === "2") ||
                (docIsINV === 1 && window.location.pathname === "/bill")) && (
                  <button
                    onClick={() => setShowOptionInvModal(true)}
                    className="btn btn-lg"
                    style={{
                      fontSize: "16px",
                      color: "white",
                      marginRight: "10px",
                      backgroundColor: "purple",
                      fontWeight: "bold",
                    }}
                  >
                    <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                    &ensp;ใบกำกับภาษี
                  </button>
                )}
              <PrintInvoiceModal
                showOptionInvModal={showOptionInvModal}
                setShowOptionInvModal={setShowOptionInvModal}
                onHandleInvoice1={onHandleInvoice1}
                onHandleInvoice2={onHandleInvoice2}
                onHandleInvoice3={onHandleInvoice3}
                invNo={docInvNo}
              />
              <button
                hidden={
                  window.location.pathname === "/billofsale" ? false : true
                }
                onClick={() => onHandlePayslip()}
                className="btn btn-lg btn-success"
                style={{
                  fontSize: "16px",
                  color: "white",
                  marginRight: "10px",
                  fontWeight: "bold",
                }}
              >
                <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                &ensp;ใบสลิป
              </button>

              {window.location.pathname === "/bill" &&
                statusName === "จ่ายครบ" && (
                  <button
                    hidden={isHiddenPath()}
                    onClick={() => onHandleInvoice3()}
                    className="btn btn-lg shadow text-white"
                    style={{
                      fontSize: "16px",
                      color: "white",
                      marginRight: "10px",
                      fontWeight: "bold",
                      backgroundColor: "purple",
                    }}
                  >
                    <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                    &ensp;ใบเสร็จรับเงิน
                  </button>
                )}

              {window.location.pathname === "/billofsale" ? (
                otherTypeName === "เครดิต" ? (
                  isVatChecked ? (
                    otherStatusName === "จ่ายครบ" ? (
                      <>
                        <button
                          hidden={isHiddenPath()}
                          onClick={() => onHandleClick()}
                          className="btn btn-lg shadow text-white"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                            backgroundColor: "purple",
                          }}
                          disabled={true}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบเสร็จรับเงิน/ใบกำกับภาษี
                        </button>
                        <button
                          hidden={isHiddenPath()}
                          onClick={() => onHandleClick()}
                          className="btn btn-lg btn-primary"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบส่งของ/ใบกำกับภาษี
                        </button>
                      </>
                    ) : (
                      <button
                        hidden={isHiddenPath()}
                        onClick={() => onHandleClick()}
                        className="btn btn-lg btn-primary"
                        style={{
                          fontSize: "16px",
                          color: "white",
                          marginRight: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        <i
                          className="fa fa-print"
                          style={{ fontSize: "16px" }}
                        ></i>
                        &ensp;ใบส่งของ/ใบกำกับภาษี
                      </button>
                    )
                  ) : otherStatusName === "จ่ายครบ" ? (
                    <>
                      <button
                        hidden={isHiddenPath()}
                        onClick={() => onHandleClick()}
                        className="btn btn-lg shadow text-white"
                        style={{
                          fontSize: "16px",
                          color: "white",
                          marginRight: "10px",
                          fontWeight: "bold",
                          backgroundColor: "purple",
                        }}
                        disabled={true}
                      >
                        <i
                          className="fa fa-print"
                          style={{ fontSize: "16px" }}
                        ></i>
                        &ensp;ใบเสร็จรับเงิน
                      </button>
                      <button
                        hidden={isHiddenPath()}
                        onClick={() => onHandleClick()}
                        className="btn btn-lg btn-primary"
                        style={{
                          fontSize: "16px",
                          color: "white",
                          marginRight: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        <i
                          className="fa fa-print"
                          style={{ fontSize: "16px" }}
                        ></i>
                        &ensp;ใบส่งของ/ใบแจ้งหนี้
                      </button>
                    </>
                  ) : (
                    <button
                      hidden={isHiddenPath()}
                      onClick={() => onHandleClick()}
                      className="btn btn-lg btn-primary"
                      style={{
                        fontSize: "16px",
                        color: "white",
                        marginRight: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      <i
                        className="fa fa-print"
                        style={{ fontSize: "16px" }}
                      ></i>
                      &ensp;ใบส่งของ/ใบแจ้งหนี้
                    </button>
                  )
                ) : isVatChecked ? (
                  <>
                    <button
                      hidden={isHiddenPath()}
                      onClick={() => onHandleInvoice3()}
                      className="btn btn-lg shadow text-white"
                      style={{
                        fontSize: "16px",
                        color: "white",
                        marginRight: "10px",
                        fontWeight: "bold",
                        backgroundColor: "purple",
                      }}
                    >
                      <i
                        className="fa fa-print"
                        style={{ fontSize: "16px" }}
                      ></i>
                      &ensp;ใบเสร็จรับเงิน
                    </button>
                    <button
                      hidden={isHiddenPath()}
                      onClick={() => onHandleClick()}
                      className="btn btn-lg btn-primary"
                      style={{
                        fontSize: "16px",
                        color: "white",
                        marginRight: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      <i
                        className="fa fa-print"
                        style={{ fontSize: "16px" }}
                      ></i>
                      &ensp;ใบส่งของ/ใบกำกับภาษี
                    </button>
                  </>
                ) : (
                  <button
                    hidden={isHiddenPath()}
                    onClick={() => onHandleClick()}
                    className="btn btn-lg btn-primary"
                    style={{
                      fontSize: "16px",
                      color: "white",
                      marginRight: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                    &ensp;ใบส่งของ/ใบเสร็จรับเงิน
                  </button>
                )
              ) : window.location.pathname === "/bill" ? (
                <button
                  hidden={isHiddenPath()}
                  onClick={() => onHandleClick()}
                  className="btn btn-lg btn-primary"
                  style={{
                    fontSize: "16px",
                    color: "white",
                    marginRight: "10px",
                    fontWeight: "bold",
                  }}
                >
                  <i className="fa fa-print" style={{ fontSize: "16px" }}></i>
                  &ensp;
                  {window.location.pathname === "/bill" ? "ใบวางบิล" : "รายงาน"}
                </button>
              ) : (
                <>
                  <div className="d-flex gap-2">
                    <button
                      hidden={isHiddenPath()}
                      onClick={() => onHandleClick()}
                      className="btn btn-primary d-flex align-items-center justify-content-center"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        fontSize: "16px",
                        color: "white",
                        fontWeight: "bold",
                        padding: 0,
                      }}
                    >
                      <i className="fa fa-print"></i>
                    </button>
                    <div style={{ marginRight: "18px" }} />
                  </div>
                </>
              )}
            </>
          ) : (
            <div style={{ marginRight: "15px" }} />
          )}
        </div>
        <div style={{ marginRight: "30px" }} />
        {/* Modal สำหรับแสดงสลิปเงินโอน */}
        {showSlipModal && (
          <div
            className="modal"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-md" role="document">
              <div
                className="modal-content shadow-lg"
                style={{
                  borderRadius: "15px",
                  overflow: "hidden",
                  maxHeight: "auto",
                }}
              >
                <div
                  className="modal-header"
                  style={{
                    backgroundColor: "#EF6C00",
                    borderBottom: "none",
                    padding: "15px",
                  }}
                >
                  <h5 className="modal-title fw-bold text-white">
                    ชำระเงิน เมื่อวันที่ {payDatetime}
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => {
                      setShowSlipModal(false);
                      setBase64Image(null);
                    }}
                    aria-label="Close"
                  ></button>
                </div>
                {window.location.pathname === "/bill" ||
                  window.location.pathname === "/billofsale" ? (
                  <div
                    className="modal-body"
                    style={{
                      padding: "20px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    {uploadedSlipFiles.length === 0 ? (
                      // ไม่มีไฟล์ - แสดง UI อัพโหลด
                      <>
                        <h4 style={{ textAlign: "center" }}>ไม่พบรูปภาพสลิป</h4>

                        <div className="mt-3 text-center w-100">
                          <input
                            type="file"
                            id="multipleFileInput"
                            style={{ display: "none" }}
                            onChange={handleMultipleSlipUpload}
                            accept=".png, .jpg, .jpeg, .gif, .svg"
                            multiple
                          />

                          <button
                            className="btn mb-3"
                            onClick={() =>
                              document
                                .getElementById("multipleFileInput")
                                .click()
                            }
                            style={{
                              borderRadius: "5px",
                              backgroundColor: "#EF6C00",
                              color: "#fff",
                              padding: "12px 24px",
                              fontSize: "16px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                              transition: "background-color 0.3s",
                            }}
                            disabled={
                              multipleSlipImages.length >= 100
                            }
                          >
                            <i className="fa fa-plus me-2"></i>
                            เลือกไฟล์สลิป
                          </button>

                          <div className="text-muted small mb-3">
                            ไฟล์ที่เลือกแล้ว: {multipleSlipImages.length}
                          </div>

                          {multipleSlipImages.length > 0 && (
                            <div className="row g-3 mb-3">
                              {multipleSlipImages.map((image, index) => (
                                <div key={image.id} className="col-12">
                                  <div
                                    className="card"
                                    style={{
                                      border: "1px solid #ddd",
                                      borderRadius: "8px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div className="card-header bg-light d-flex justify-content-between align-items-center py-2">
                                      <span className="fw-bold">
                                        ไฟล์ที่ {index + 1}
                                      </span>
                                      <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() =>
                                          handleRemoveSlipImage(image.id)
                                        }
                                        style={{
                                          borderRadius: "50%",
                                          width: "30px",
                                          height: "30px",
                                          padding: "0",
                                        }}
                                      >
                                        <i className="fa fa-times"></i>
                                      </button>
                                    </div>
                                    <div className="card-body p-2">
                                      {image.type.startsWith("image/") ? (
                                        <img
                                          src={image.base64}
                                          alt={`สลิปที่ ${index + 1}`}
                                          style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            objectFit: "contain",
                                            borderRadius: "5px",
                                          }}
                                        />
                                      ) : (
                                        <div className="text-center p-3">
                                          <i className="fa fa-file-pdf fa-3x text-danger mb-2"></i>
                                          <div className="small text-muted">
                                            {image.name}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}

                          {multipleSlipImages.length > 0 && (
                            <div className="d-flex gap-2 justify-content-center">
                              <button
                                className="btn btn-success"
                                onClick={handleUploadMultipleSlips}
                                style={{
                                  borderRadius: "5px",
                                  padding: "10px 20px",
                                  fontSize: "16px",
                                }}
                              >
                                <i className="fa fa-upload me-2"></i>
                                อัพโหลดสลิป ({multipleSlipImages.length} ไฟล์)
                              </button>
                              <button
                                className="btn btn-danger"
                                onClick={() => setMultipleSlipImages([])}
                                style={{
                                  borderRadius: "5px",
                                  padding: "10px 20px",
                                  fontSize: "16px",
                                }}
                              >
                                <i className="fa fa-times me-2"></i>
                                ยกเลิกทั้งหมด
                              </button>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      // มีไฟล์แล้ว - แสดงไฟล์ที่อัพโหลดไว้
                      <div style={{ width: "100%" }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="fw-bold mb-0">
                            ไฟล์สลิปที่อัพโหลดแล้ว ({uploadedSlipFiles.length}{" "} ไฟล์)
                          </h5>
                          {uploadedSlipFiles.length < 100 && (
                            <button
                              className="btn btn-sm"
                              onClick={() =>
                                document
                                  .getElementById("multipleFileInput")
                                  .click()
                              }
                              style={{
                                backgroundColor: "#28a745",
                                color: "#fff",
                                borderRadius: "5px",
                                padding: "6px 12px",
                              }}
                            >
                              <i className="fa fa-plus me-1"></i>
                              เพิ่มไฟล์
                            </button>
                          )}
                        </div>

                        <div className="row g-3">
                          {uploadedSlipFiles.map((file, index) => (
                            <div key={file.id} className="col-12">
                              <div
                                className="card"
                                style={{
                                  border: "1px solid #ddd",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                }}
                              >
                                <div className="card-header bg-light d-flex justify-content-between align-items-center py-2">
                                  <span className="fw-bold">
                                    ไฟล์ที่ {index + 1}: {file.fileName}
                                  </span>
                                  <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() =>
                                      handleDeleteSingleFile(file)
                                    }
                                    style={{
                                      borderRadius: "50%",
                                      width: "30px",
                                      height: "30px",
                                      padding: "0",
                                    }}
                                    title="ลบไฟล์นี้"
                                  >
                                    <i className="fa fa-times"></i>
                                  </button>
                                </div>
                                <div className="card-body p-2">
                                  <img
                                    src={file.fileUrl}
                                    alt={`สลิปที่ ${index + 1}`}
                                    style={{
                                      width: "100%",
                                      maxHeight: "300px",
                                      objectFit: "contain",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      window.open(file.fileUrl, "_blank")
                                    }
                                  />
                                  <div className="mt-2 text-muted small">
                                    อัพโหลดโดย: {file.uploadBy} | วันที่:{" "}
                                    {formatDate(file.uploadDate)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {uploadedSlipFiles.length < 3 && (
                          <>
                            <input
                              type="file"
                              id="multipleFileInput"
                              style={{ display: "none" }}
                              onChange={handleMultipleSlipUpload}
                              accept=".png, .jpg, .jpeg, .gif, .svg"
                              multiple
                            />

                            {multipleSlipImages.length > 0 && (
                              <div className="mt-3">
                                <hr />
                                <h6 className="fw-bold">ไฟล์ที่เลือกใหม่:</h6>
                                <div className="row g-2">
                                  {multipleSlipImages.map((image, index) => (
                                    <div key={image.id} className="col-6">
                                      <div
                                        className="card"
                                        style={{ border: "1px solid #ddd" }}
                                      >
                                        <div className="card-body p-2 text-center">
                                          {image.type.startsWith("image/") ? (
                                            <img
                                              src={image.base64}
                                              alt={`ใหม่ ${index + 1}`}
                                              style={{
                                                width: "100%",
                                                maxHeight: "100px",
                                                objectFit: "contain",
                                              }}
                                            />
                                          ) : (
                                            <i className="fa fa-file-pdf fa-2x text-danger"></i>
                                          )}
                                          <button
                                            className="btn btn-sm btn-danger mt-1"
                                            onClick={() =>
                                              handleRemoveSlipImage(image.id)
                                            }
                                            style={{ fontSize: "12px" }}
                                          >
                                            ลบ
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>

                                <div className="text-center mt-3">
                                  <button
                                    className="btn btn-success me-2"
                                    onClick={handleUploadMultipleSlips}
                                    style={{ fontSize: "14px" }}
                                  >
                                    <i className="fa fa-upload me-1"></i>
                                    อัพโหลด ({multipleSlipImages.length} ไฟล์)
                                  </button>
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => setMultipleSlipImages([])}
                                    style={{ fontSize: "14px" }}
                                  >
                                    ยกเลิก
                                  </button>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}

                    {/* ส่วนรายละเอียดธนาคาร - คงเดิม */}
                    <div style={{ width: "100%", marginTop: "20px" }}>
                      <h5
                        className="fw-bold mb-3"
                        style={{
                          borderBottom: "1px solid #ddd",
                          paddingBottom: "8px",
                        }}
                      >
                        รายละเอียดธนาคาร
                      </h5>
                      <div style={{ marginBottom: "12px" }}>
                        <span className="fw-bold">ธนาคาร: </span>
                        <span>
                          {(() => {
                            const targetPayment = paymentHistory.find(
                              (p) => p.Pay_Type === 2
                            );
                            if (!targetPayment) return "-";
                            if (targetPayment.Bank_Id) {
                              const bank = bankDataList.find(
                                (b) => b.Bank_Id === targetPayment.Bank_Id
                              );
                              return bank ? bank.B_Name_TH : "-";
                            } else {
                              const bank = masterBankDataList.find(
                                (b) =>
                                  b.Bank_Master_Id ===
                                  targetPayment.Bank_Master_Id
                              );
                              return bank ? bank.B_Name_TH : "-";
                            }
                          })()}
                        </span>
                      </div>
                      <div style={{ marginBottom: "12px" }}>
                        <span className="fw-bold">เลขที่บัญชี: </span>
                        <span>
                          {(() => {
                            const targetPayment = paymentHistory.find(
                              (p) => p.Pay_Type === 2
                            );
                            if (!targetPayment) return "-";
                            if (targetPayment.Bank_Id) {
                              const bank = bankDataList.find(
                                (b) => b.Bank_Id === targetPayment.Bank_Id
                              );
                              return bank ? bank.Bank_Account || "-" : "-";
                            } else {
                              return targetPayment.Pay_To_Acc_No || "-";
                            }
                          })()}
                        </span>
                      </div>
                      <div style={{ marginBottom: "12px" }}>
                        <span className="fw-bold">ชื่อบัญชี: </span>
                        <span>
                          {(() => {
                            const targetPayment = paymentHistory.find(
                              (p) => p.Pay_Type === 2
                            );
                            if (!targetPayment) return "-";
                            if (targetPayment.Bank_Id) {
                              const bank = bankDataList.find(
                                (b) => b.Bank_Id === targetPayment.Bank_Id
                              );
                              return bank ? bank.Bank_Name_TH || "-" : "-";
                            } else {
                              return targetPayment.Pay_To_Acc_Name || "-";
                            }
                          })()}
                        </span>
                      </div>
                      {(() => {
                        const targetPayment = paymentHistory.find(
                          (p) => p.Pay_Type === 2
                        );
                        if (targetPayment && targetPayment.Bank_Id) {
                          const bank = bankDataList.find(
                            (b) => b.Bank_Id === targetPayment.Bank_Id
                          );
                          let label = "ชื่อเจ้าหนี้";
                          if (bank?.APAR_Type === "AR") {
                            label = "ชื่อลูกหนี้";
                          } else if (bank?.APAR_Type === "CP") {
                            label = "ชื่อบริษัท";
                          }
                          return (
                            <div>
                              <span className="fw-bold">{label}: </span>
                              <span>{bank?.NName || "-"}</span>
                            </div>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  </div>
                ) : (
                  <div
                    className="modal-body"
                    style={{
                      padding: "20px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <>
                      {!urlImg ||
                        (Array.isArray(urlImg) && urlImg.length === 0) ||
                        !urlImg.length ? (
                        <>
                          <h4 style={{ textAlign: "center" }}>
                            ไม่พบรูปภาพ {urlImg}
                          </h4>
                          <div
                            className="mt-3 text-center"
                            hidden={
                              window.location.pathname === "/payment-voucher"
                            }
                          >
                            <input
                              type="file"
                              id="fileInput"
                              style={{ display: "none" }}
                              onChange={handleUploadSlip}
                              accept=".png, .jpg, .jpeg, .gif, .svg"
                            />
                            {window.location.pathname !== "/payment-voucher" &&
                              window.location.pathname !== "/billofsale" && (
                                <button
                                  className="btn"
                                  onClick={() =>
                                    document.getElementById("fileInput").click()
                                  }
                                  style={{
                                    borderRadius: "5px",
                                    backgroundColor: "#EF6C00",
                                    color: "#fff",
                                    padding: "8px 16px",
                                    fontSize: "14px",
                                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                                    transition: "background-color 0.3s",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.backgroundColor = "#d85d00")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.backgroundColor = "#EF6C00")
                                  }
                                >
                                  อัพโหลดสลิป
                                </button>
                              )}
                            {base64Image && (
                              <div className="mt-3">
                                <p
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    color: "#333",
                                  }}
                                >
                                  รูปภาพสลิป:
                                </p>
                                <img
                                  src={base64Image}
                                  alt="อัพโหลดสลิป"
                                  style={{
                                    maxWidth: "50%",
                                    border: "1px solid #ddd",
                                    borderRadius: "5px",
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                  }}
                                />
                                <div style={{ marginTop: "15px" }}>
                                  <button
                                    className="btn"
                                    onClick={handleUpdateSlip}
                                    style={{
                                      backgroundColor: "#4CAF50",
                                      color: "#fff",
                                      borderRadius: "5px",
                                      padding: "8px 16px",
                                      fontSize: "14px",
                                      marginRight: "10px",
                                    }}
                                  >
                                    ยืนยัน
                                  </button>
                                  <button
                                    className="btn"
                                    onClick={() => setBase64Image(null)}
                                    style={{
                                      backgroundColor: "#f44336",
                                      color: "#fff",
                                      borderRadius: "5px",
                                      padding: "8px 16px",
                                      fontSize: "14px",
                                    }}
                                  >
                                    ยกเลิก
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      ) : (
                        // แสดงรูปที่มีอยู่แล้ว (เดิม)
                        <div
                          style={{ textAlign: "center", position: "relative" }}
                        >
                          {Array.isArray(urlImg) ? (
                            urlImg.map((img, index) => (
                              <div
                                key={index}
                                style={{
                                  position: "relative",
                                  display: "inline-block",
                                  width: "100%",
                                }}
                              >
                                <img
                                  src={img}
                                  alt={`ชำระเงิน ${index + 1}`}
                                  style={{
                                    width: "100%",
                                    height: "auto",
                                    borderRadius: "10px",
                                    display: "block",
                                    margin: "10px auto",
                                  }}
                                />
                                <button
                                  className="btn btn-danger position-absolute top-0 start-0 translate-middle"
                                  style={{
                                    borderRadius: "50%",
                                    width: "30px",
                                    height: "30px",
                                    fontSize: "16px",
                                    padding: "0",
                                    backgroundColor: "red",
                                    color: "white",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onClick={() =>
                                    setShowConfirmRemoveModal(true)
                                  }
                                >
                                  <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            ))
                          ) : (
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                                width: "100%",
                              }}
                            >
                              <img
                                src={urlImg}
                                alt="ชำระเงิน"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  borderRadius: "10px",
                                  display: "block",
                                  margin: "10px auto",
                                }}
                              />
                              <button
                                className="btn btn-danger position-absolute top-0 start-0 translate-middle"
                                style={{
                                  borderRadius: "50%",
                                  width: "30px",
                                  height: "30px",
                                  fontSize: "16px",
                                  padding: "0",
                                  backgroundColor: "red",
                                  color: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => setShowConfirmRemoveModal(true)}
                              >
                                <i
                                  className="fa fa-times"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </div>
                          )}
                        </div>
                      )}

                      {/* ส่วนรายละเอียดธนาคารเดิม */}
                      <div style={{ width: "100%", marginTop: "20px" }}>
                        <h5
                          className="fw-bold mb-3"
                          style={{
                            borderBottom: "1px solid #ddd",
                            paddingBottom: "8px",
                          }}
                        >
                          รายละเอียดธนาคาร
                        </h5>
                        <div style={{ marginBottom: "12px" }}>
                          <span className="fw-bold">ธนาคาร: </span>
                          <span>
                            {(() => {
                              const targetPayment = paymentHistory.find(
                                (p) => p.Pay_Type === 2
                              );
                              if (!targetPayment) return "-";
                              if (targetPayment.Bank_Id) {
                                const bank = bankDataList.find(
                                  (b) => b.Bank_Id === targetPayment.Bank_Id
                                );
                                return bank ? bank.B_Name_TH : "-";
                              } else {
                                const bank = masterBankDataList.find(
                                  (b) =>
                                    b.Bank_Master_Id ===
                                    targetPayment.Bank_Master_Id
                                );
                                return bank ? bank.B_Name_TH : "-";
                              }
                            })()}
                          </span>
                        </div>
                        <div style={{ marginBottom: "12px" }}>
                          <span className="fw-bold">เลขที่บัญชี: </span>
                          <span>
                            {(() => {
                              const targetPayment = paymentHistory.find(
                                (p) => p.Pay_Type === 2
                              );
                              if (!targetPayment) return "-";
                              if (targetPayment.Bank_Id) {
                                const bank = bankDataList.find(
                                  (b) => b.Bank_Id === targetPayment.Bank_Id
                                );
                                return bank ? bank.Bank_Account || "-" : "-";
                              } else {
                                return targetPayment.Pay_To_Acc_No || "-";
                              }
                            })()}
                          </span>
                        </div>
                        <div style={{ marginBottom: "12px" }}>
                          <span className="fw-bold">ชื่อบัญชี: </span>
                          <span>
                            {(() => {
                              const targetPayment = paymentHistory.find(
                                (p) => p.Pay_Type === 2
                              );
                              if (!targetPayment) return "-";
                              if (targetPayment.Bank_Id) {
                                const bank = bankDataList.find(
                                  (b) => b.Bank_Id === targetPayment.Bank_Id
                                );
                                return bank ? bank.Bank_Name_TH || "-" : "-";
                              } else {
                                return targetPayment.Pay_To_Acc_Name || "-";
                              }
                            })()}
                          </span>
                        </div>
                        {(() => {
                          const targetPayment = paymentHistory.find(
                            (p) => p.Pay_Type === 2
                          );
                          if (targetPayment && targetPayment.Bank_Id) {
                            const bank = bankDataList.find(
                              (b) => b.Bank_Id === targetPayment.Bank_Id
                            );
                            let label = "ชื่อเจ้าหนี้";
                            if (bank?.APAR_Type === "AR") {
                              label = "ชื่อลูกหนี้";
                            } else if (bank?.APAR_Type === "CP") {
                              label = "ชื่อบริษัท";
                            }
                            return (
                              <div>
                                <span className="fw-bold">{label}: </span>
                                <span>{bank?.NName || "-"}</span>
                              </div>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    </>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <div
          className={`modal fade ${showConfirmRemoveModal ? "show" : ""}`}
          tabIndex="-1"
          style={{ display: showConfirmRemoveModal ? "block" : "none" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: "40%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">ยืนยันการลบรูปภาพ</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirmRemoveModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>คุณแน่ใจว่าต้องการลบรูปนี้หรือไม่?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-lg w-25 shadow text-white d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor: "#EF6C00",
                    fontSize: "16px",
                    position: "relative",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => {
                    handleConfirmDelete();
                  }}
                >
                  ยืนยัน
                </button>
                <button
                  type="button"
                  className="btn btn-lg w-25 shadow text-white"
                  style={{ backgroundColor: "red", fontSize: "16px" }}
                  onClick={() => setShowConfirmRemoveModal(false)}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Modal สำหรับแสดงเช็ค */}
        {showChequeModal && (
          <div
            className="modal"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050,
            }}
          >
            <div className="modal-dialog modal-md" role="document">
              <div
                className="modal-content shadow-lg"
                style={{ borderRadius: "15px", overflow: "hidden" }}
              >
                <div
                  className="modal-header"
                  style={{
                    backgroundColor: "#EF6C00",
                    borderBottom: "none",
                    padding: "20px",
                  }}
                >
                  <h5 className="modal-title fw-bold text-white">เช็ค</h5>
                </div>
                <div className="modal-body">
                  <div
                    class="p-3 rounded mt-4"
                    style={{ backgroundColor: "#DCDCDC" }}
                  >
                    <h6 class="fw-bold mb-3">รายละเอียดเช็ค</h6>
                    <div class="row g-3">
                      <div class="col-12">
                        <label class="form-label fw-bold">เลขที่เช็ค</label>
                        <input
                          type="text"
                          class="form-control"
                          value={chequeNo}
                          disabled={true}
                        />
                      </div>
                      <div class="col-12">
                        <label class="form-label fw-bold">ชื่อเช็ค</label>
                        <input
                          type="text"
                          class="form-control"
                          value={chequeName}
                          disabled={true}
                        />
                      </div>
                      <div class="col-12">
                        <label class="form-label fw-bold">ธนาคาร</label>
                        <input
                          type="text"
                          class="form-control"
                          value={chequeBranch}
                          disabled={true}
                        />
                      </div>
                      <div class="col-12">
                        <label class="form-label fw-bold">วันที่</label>
                        <DatePicker
                          value={chequeDate}
                          onChange={(date) =>
                            setChequeDate(
                              date ? date.format("YYYY-MM-DD") : null
                            )
                          }
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer" style={{ borderTop: "none" }}>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ borderRadius: "5px" }}
                    onClick={() => setShowChequeModal(false)}
                  >
                    ปิด
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {showConfirmDeleteSingleFile && (
        <div
          className="modal"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold">ยืนยันการลบไฟล์</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowConfirmDeleteSingleFile(false);
                    setSelectedFileToDelete(null);
                  }}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  คุณแน่ใจว่าต้องการลบไฟล์ "{selectedFileToDelete?.fileName}"
                  หรือไม่?
                </p>
                <p className="text-muted small">
                  การดำเนินการนี้ไม่สามารถยกเลิกได้
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-lg shadow text-white"
                  style={{ backgroundColor: "#EF6C00", fontSize: "16px" }}
                  onClick={confirmDeleteSingleFile}
                >
                  ยืนยันการลบ
                </button>
                <button
                  type="button"
                  className="btn btn-lg shadow text-white"
                  style={{ backgroundColor: "#6c757d", fontSize: "16px" }}
                  onClick={() => {
                    setShowConfirmDeleteSingleFile(false);
                    setSelectedFileToDelete(null);
                  }}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default Breadcrumbs;
